<template>
  <div class="version-list">
    <div class="version-content">
      <div class="title-list">
        <div
          class="title-item"
          v-for="(item, index) in titleList"
          :key="index"
          :class="[item.class]"
        >
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
      <div class="version-wrap">
        <div class="version-item" v-for="(item, index) in list" :key="index">
          <div class="item-version label">{{ item.version }}</div>
          <div class="item-app-channel" :class="{ ios: platform === 0 }">
            <img :src="item.icon_url" alt="" />
            <span class="label" v-if="$i18n.locale === 'zh'">{{ item.channel_desc }}</span>
            <span class="label" v-else>{{ item.channel_desc_en }}</span>
          </div>
          <div class="item-developer label" :class="{ ios: platform === 0 }">{{ item.developer }}</div>
           <div class="item-log label" @click="checkLog(item)" :class="{ ios: platform === 0 }">
            {{ $t('main.check') }}
          </div>
          <div class="item-md5" v-if="platform === 1">
            <span class="label">{{ item.md5 }}</span>
            <img src="../../assets/copy.png" @click="onCopy(item.md5)" alt="" />
          </div>
          <div class="item-md5 item-sha256" v-if="platform === 1">
            <span class="label">{{ item.sha256 }}</span>
            <img
              src="../../assets/copy.png"
              @click="onCopy(item.sha256)"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="version-right" :class="{ android: platform === 1}">
      <div class="about-ios">
        <div class="title">{{ versionData.title }}</div>
        <div class="desc" v-for="(desc,index) in versionData.desc" :key="index">{{ desc }}</div>
        <div class="app-name">
          <p class="name-title">{{ $t('main.IOSAppName') }}</p>
          <p>{{ versionData.name }}</p>
        </div>
        <div class="app-name app-icon">
          <p class="name-title">{{ $t('main.AppIcon') }}</p>
          <img :src="versionData.icon" alt="" />
        </div>
        <div class="app-name app-developer">
          <p class="name-title">{{ $t('main.AppDeveloper') }}</p>
          <p>TP Global Ltd</p>
        </div>
        <div class="app-name download-link">
          <p class="name-title">{{ $t('main.downloadLink') }}</p>
          <a :href="link" target="_blank" v-for="(link,index) in versionData.links" :key="index">{{ link }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 平台 0 ios, 1 android
    platform: {
      type: Number,
      default: 1,
    },
    list: {
      type: Array,
    },
  },

  computed: {
    versionData() {
      if (this.platform === 0) {
        return {
          title: this.$t('main.aboutIOS'),
          desc: [this.$t('main.IOSDesc'),this.$t('main.IOSDesc_2')],
          name: 'TP Wallet',
          icon: require('../../assets/TP-wallet.png'),
          developer: 'TP Global Ltd',
          links: ['https://apps.apple.com/hk/app/tp-global-wallet/id6444625622']
        }
      } else {
        return {
          title: this.$t('main.aboutAndroid'),
          desc: [this.$t('main.androidDesc')],
          name: 'TokenPocket',
          icon: require('../../assets/TokenPocket.png'),
          developer: 'TP Global Ltd',
          links: ['https://tokenpocket.pro', 'https://tpwallet.io']
        }
      }
    },
    androidTitleList() {
      return [
        { title: this.$t('main.version'), class: 'item-version' },
        { title: this.$t('main.appChannel'), class: 'item-app-channel' },
        { title: this.$t('main.developer'), class: 'item-developer' },
        { title: this.$t('main.log'), class: 'item-log' },
        { title: this.$t('main.md5'), class: 'item-md5' },
        { title: this.$t('main.sha256'), class: 'item-sha256' },
      ];
    },
    iosTitleList() {
      return [
        { title: this.$t('main.version'), class: 'item-version' },
        { title: this.$t('main.appChannel'), class: 'item-app-channel ios' },
        { title: this.$t('main.developer'), class: 'item-developer' },
        { title: this.$t('main.log'), class: 'item-log ios' },
      ];
    },
    titleList() {
      if (this.platform === 1) {
        return this.androidTitleList;
      } else {
        return this.iosTitleList;
      }
    },
  },
  methods: {
    checkLog(item) {
      this.$emit('getVersionLog', item);
    },
    onCopy(message) {
      this.$copyText(message).then(() => {
        // console.log('message', message);
        alert(this.$t('main.copied'));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.version-list {
  width: 1200px;
  background: #f3f5f7;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  .version-content {
    flex: 1;
    .item-version {
      margin-left: 32px;
      flex: 0.8;
    }
    .item-app-channel {
      flex: 1;
      // margin-left: 10px;
      &.ios {
        // margin-left: 32px;
        flex: 1.4;
      }
    }
    .item-developer {
      flex: 1;
      margin-left: 20px;
      // &.ios {
      //   margin-left: 40px;
      // }
    }
    .item-md5 {
      flex: 2;
      margin-left: 20px;
    }
    .item-sha256 {
      flex: 2;
      margin-left: 30px;
      margin-right: 20px;
    }
    .item-log {
      flex: 1;
      margin-left: 32px;
      &.ios {
        margin-left: 32px;
      }
    }
    .title-list {
      display: flex;
      justify-content: space-between;
      background: #fff;
      border-radius: 8px;
      padding: 16px 0;
      .title-item {
        display: flex;
        align-items: center;
        .title {
          font-size: 12px;
          font-weight: 400;
          color: #9ea0a5;
        }
      }
    }
    .version-wrap {
      margin-top: 12px;
      height: 800px;
      overflow: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .version-item {
        background: #fff;
        border-radius: 8px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 0;
        &:nth-child(n + 2) {
          margin-top: 12px;
        }
        .label {
          font-size: 12px;
          font-weight: 500;
          color: #3a3b3d;
        }
        .item-version {
          font-size: 14px;
          font-weight: 500;
          color: #3a3b3d;
        }
        .item-app-channel {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            cursor: pointer;
          }
          span {
            margin-left: 10px;
          }
        }
        .item-md5 {
          display: flex;
          align-items: center;
          span {
            word-break: break-all;
          }
          img {
            margin-left: 6px;
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
        }
        .item-sha256 {
          // flex: 3;
        }
        .item-log {
          color: #2980fe;
          cursor: pointer;
        }
      }
    }
  }
  .version-right {
    margin-left: 16px;
    width: 376px;
    background: #ffffff;
    border-radius: 16px;
    padding: 32px 20px 20px 20px;
    &.android {
      width: 280px;
    }
    .about-ios {
      .title {
        font-size: 24px;
        font-weight: 600;
        color: #3a3b3d;
      }
      .desc {
        margin-top: 16px;
        font-size: 13px;
        color: #9ea0a5;
        letter-spacing: 0.5px;
        line-height: 18px;
      }
      p {
        font-size: 14px;
        font-weight: 500;
        color: #3a3b3d;
        line-height: 24px;
      }
      .app-name {
        margin-top: 32px;
        .name-title {
          color: #bdbdbd;
          margin-bottom: 4px;
          font-weight: 400;
        }
      }
      .app-icon {
        img {
          width: 88px;
          height: 88px;
        }
      }
      .download-link {
        a {
          display: block;
          margin-top: 4px;
          color: #2980fe;
          line-height: 22px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .version-list {
    .version-content {
      .title-list {
        .title-item {
          .title {
            font-size: 13px;
          }
        }
      }
      .version-wrap {
        // height: 560px;
        .version-item {
          .label {
            font-size: 13px;
          }
        }
      }
    }
    .version-right {
      border-radius: 10px;
    }
  }
}
</style>
